import {emotionStyled, tokens} from '@packages/utilities/styled';

import {RowItemBodyView} from '../../RowItem/RowItemBody';
import {
  SearchableListItem,
  SearchableListItemBody,
  SearchableListItemActions,
  SearchableListItemAdornment,
} from '../../SearchableList';
import type {SearchableListItemProps} from '../../SearchableList/SearchableListItem/SearchableListItem';

export const AutocompleteItemBody = emotionStyled(SearchableListItemBody)({
  /**
   * Override the default RowItem padding and RowItemBody minHeight
   * to match the Autocomplete option padding and minHeight.
   */
  padding: tokens.ui.autocomplete.option.padding,

  [`${RowItemBodyView}`]: {
    minHeight: tokens.ui.autocomplete.option.minHeight,
  },
});

AutocompleteItemBody.displayName = 'AutocompleteItemBody';

/**
 * AutocompleteItem
 *
 * A wrapper component for rendering custom Autocomplete options.
 *
 * ## Usage
 *
 * ```tsx
 * import {Autocomplete, AutocompleteItem, AutocompleteItemBody} from '@packages/systems/spring';
 *
 * const renderOption = (option, state) => (
 *   <AutocompleteItem isDisabled={option.isDisabled} prefix={option.icon}>
 *     <AutocompleteItemBody description={option.description}>
 *       {option.label}
 *     </AutocompleteItemBody>
 *   </AutocompleteItem>
 * );
 *
 * <Autocomplete options={options} renderOption={renderOption} />
 * ```
 */
export const AutocompleteItem = SearchableListItem;

export type AutocompleteItemProps = SearchableListItemProps;

/**
 * Re-export sub-components for use within AutocompleteItem
 */
export const AutocompleteItemAdornmentWrapper = SearchableListItemActions;
export const AutocompleteItemAdornment = SearchableListItemAdornment;
